import './FormControl.scss'

import { ErrorMessage, FieldTextV6, Icon } from '@tallink/components-lib'
import * as PropTypes from 'prop-types'
import React from 'react'

export default function FormControl({ label, error, name, inputRef, onChange, isFieldDisabled, touched }) {
  return (
    <div className="form-control">
      <div className="field">
        <label htmlFor={name}>{label}</label>
        <FieldTextV6
          className="field-input"
          disabled={isFieldDisabled}
          id={name}
          inputRef={inputRef}
          invalid={!!error}
          name={name}
          onChange={onChange}
        />
        {touched && !error && <Icon className="field-valid" size="m" type="check" />}
      </div>
      {!!error && <ErrorMessage message={error.message} />}
    </div>
  )
}

FormControl.propTypes = {
  error: PropTypes.object,
  inputRef: PropTypes.func.isRequired,
  isFieldDisabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  touched: PropTypes.bool
}
